/**
 * CouponInput - Promo/coupon code input field
 *
 * Features:
 * - Validates coupon on blur
 * - Shows validation error messages
 * - Triggers price recalculation when coupon is entered
 */

import { FormField } from './FormField';

interface CouponInputProps {
  /** Current coupon value */
  value: string;
  /** Callback when coupon changes */
  onChange: (value: string) => void;
  /** Callback when coupon should be validated (on blur) */
  onValidate?: () => void;
  /** Error message from coupon validation */
  error?: string | null;
  /** Whether the input is disabled */
  disabled?: boolean;
}

export function CouponInput({
  value,
  onChange,
  onValidate,
  error,
  disabled,
}: CouponInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleBlur = () => {
    if (value && onValidate) {
      onValidate();
    }
  };

  return (
    <FormField
      label="Promo Code"
      name="coupon"
      type="text"
      placeholder="Enter promo code"
      autoComplete="off"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error || undefined}
      disabled={disabled}
    />
  );
}

export default CouponInput;
